type ChartSeries = {
  name: string;
  data: number[];
};

type LineChartData = {
  options: {
    chart: { id: string };
    legend: { position: string; fontFamily: string };
    dataLabels: { enabled: boolean };
    grid: { strokeDashArray: number; row: Record<string, never>; padding: { right: number; left: number } };
    xaxis: { categories: string[] };
  };
  series: ChartSeries[];
};

export const chartData: LineChartData = {
    options: {
      chart: {
        id: "line",
      },
      legend: {
        position: "bottom",
        fontFamily: "Nunito, sans-serif"
      },
      dataLabels: {
        enabled: false
      },
      grid: {
        strokeDashArray: 2,
        row: {},
        padding: {
            right: 25,
            left: 15
        }
      },
      xaxis: {
        categories: ['01/10/2024', '02/10/2024', '03/10/2024', '04/10/2024', '05/10/2024', '06/10/2024', '07/10/2024', '08/10/2024', '09/10/2024', '10/10/2024', '11/10/2024', '12/10/2024', '13/10/2024', '14/10/2024'],
      }
    },
    series: [
      {
        name: "Active Alarms",
        data: [12, 19, 13, 11, 12, 14, 13, 16, 18, 22, 14, 13, 16, 13]
      },
      {
        name: "Inactive Alarms",
        data: [12, 9, 4, 6, 9, 13, 14, 12, 19, 13, 11, 15, 17, 12]
      },
      {
        name: "Pending",
        data: [11, 5, 3, 7, 5, 8, 11, 12, 9, 4, 6, 9, 13, 14]
      }
    ]
  };
